/**
 * Created by dafre on 5/11/2017.
 */

export class WebGLTextureEnh {
  public texture : WebGLTexture;
  public image : HTMLImageElement;

}



// WEBPACK FOOTER //
// ./src/app/WebGLTextureEnh.ts